import React from 'react';
import { Code, Server, Layout, Database, Terminal, Smartphone } from 'lucide-react';
import Services from '../sections/Services';
import Button from '../components/Button';

const ServicesPage = () => {
  return (
    <div className="pt-24 min-h-screen">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-b from-navy/5 to-white border-b border-navy/5">
        <div className="container-custom text-center">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-primary font-semibold text-sm tracking-wide uppercase">Services</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6">
            Technology Solutions<br className="hidden md:block" />
            <span className="text-primary">Engineered for Enterprise Performance</span>
          </h1>
          <p className="text-lg md:text-xl text-navy/70 max-w-3xl mx-auto leading-relaxed">
            From custom software to cloud, data and security, our IT services are built to enterprise-ready standards — combining security, quality and measurable outcomes to help your business modernize, scale and stay ahead.
          </p>
        </div>
      </section>

      {/* Main Services Module */}
      <div className="relative z-10 -mt-10">
        <Services />
      </div>

      {/* Tech Stack Section */}
      <section className="py-24 bg-navy">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Our Tech Stack</h2>
          <p className="text-white/70 max-w-2xl mx-auto text-lg mb-16">
            We operate on the bleeding edge. Utilizing the most robust and modern technologies allows us to build secure, scalable, and fast software.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { icon: Layout, label: "React & Next.js" },
              { icon: Terminal, label: "Node & Python" },
              { icon: Database, label: "PostgreSQL" },
              { icon: Server, label: "AWS & AWS GCP" },
              { icon: Smartphone, label: "React Native" },
              { icon: Code, label: "TypeScript" },
            ].map((tech, i) => (
              <div key={i} className="flex flex-col items-center justify-center p-6 bg-white/5 border border-white/10 rounded-2xl hover:bg-white/10 transition-colors">
                <tech.icon size={32} className="text-primary-light mb-4" />
                <span className="text-white font-medium">{tech.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process CTA */}
      <section className="py-24 bg-gradient-to-t from-primary/10 to-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-navy mb-6">Ready to scale your product?</h2>
          <p className="text-lg md:text-xl text-navy/70 max-w-2xl mx-auto leading-relaxed mb-10">
            Let's discuss how our engineering team can integrate with yours to accelerate your roadmap.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href='/contact'> <Button variant="primary" className="px-8 py-4 text-lg">
              Book a Consultation
            </Button></a>
            {/* <Button variant="outline" className="px-8 py-4 text-lg border-navy/20 hover:bg-navy hover:text-white">
              View Case Studies
            </Button> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
